module.exports = __webpack_public_path__ + "img/nove_bloky.28696a04.jpg";